import { Footer as FooterComponent } from "components/Footer/Footer";
import { graphql, SliceComponentProps } from "gatsby";
import React from "react";
import { isPresent } from "src/utils/checks";
import { FooterMenuGroupsQuery } from "types/graphql-types";
import SliceProviders from "./SliceProviders";
import { FooterSliceContext } from "./types";

const Footer: React.FC<
  SliceComponentProps<FooterMenuGroupsQuery, FooterSliceContext>
> = ({ data, sliceContext }) => {
  const searchUrl = data.globalSearchPagePath;
  const raqUrl = data.raqPagePath;
  const rabUrl = data.rabPagePath;
  const footerMenuGroups = data.site?.footerMenuGroups?.filter(isPresent) || [];

  return (
    <SliceProviders languageCode={sliceContext.languageCode}>
      <FooterComponent
        searchPageUrl={searchUrl}
        raqUrl={raqUrl}
        rabUrl={rabUrl}
        urls={sliceContext.urls}
        footerMenuGroups={footerMenuGroups}
        subscribeFormTitle={
          data.subscribeFormContent?.heading?.title?.localized
        }
        subscribeFormContent={
          data.subscribeFormContent?.heading?.content?.localized
        }
        subscribeFooterContent={
          data.subscribeFormContent?.footerContent?.localized
        }
        formDisclaimerContent={data.formDisclaimerContent}
        subscribePrivacyPolicyUrl={sliceContext.subscribePrivacyPolicyUrl}
        offerPageUrl={data.offerPage?.fullPath}
        promoConfigurationCode={
          data.subscribeFormContent?.promoConfiguration?.code
        }
      />
    </SliceProviders>
  );
};

// eslint-disable-next-line import/no-unused-modules
export const query = graphql`
  fragment FooterMenuItemLinkCTA on SanityLinkCTA {
    _key
    _type
    label {
      localized
    }
    url {
      localized
    }
  }

  fragment FooterMenuItem on SanityMenuItem {
    _key
    _type
    target {
      ... on SanityPage {
        fullPath
        title {
          localized
        }
      }
      ... on SanityLandingPage {
        fullPath
        title {
          localized
        }
      }
      ... on SanityTermsAndConditions {
        _id
        fullPath
        title {
          localized
        }
      }

      ... on SanityOffersTermsAndConditions {
        _id
        fullPath
        title {
          localized
        }
      }
    }
    filters {
      ...AirNonAirOrLocationFilter
    }
  }

  fragment FooterMenuItems on SanityLinkCTAOrMenuItem {
    ... on SanityLinkCTA {
      ...FooterMenuItemLinkCTA
    }
    ... on SanityMenuItem {
      ...FooterMenuItem
    }
  }
  query FooterMenuGroups {
    raqPagePath
    rabPagePath
    globalSearchPagePath

    subscribeFormContent: subscribeToNewsletterContent {
      heading {
        title {
          localized
        }
        content {
          localized
        }
      }
      footerContent {
        localized
      }
      promoConfiguration {
        code
      }
    }
    formDisclaimerContent: sanityFormDisclaimer {
      ...FormDisclaimer
    }
    site: sanitySite(
      _id: { in: ["site-silversea-com", "drafts.site-silversea-com"] }
    ) {
      footerMenuGroups {
        target {
          ... on SanityPage {
            _id
            fullPath
            title {
              localized
            }
          }

          ... on SanityLandingPage {
            _id
            fullPath
            title {
              localized
            }
          }

          ... on SanityTermsAndConditions {
            _id
            fullPath
            title {
              localized
            }
          }

          ... on SanityOffersTermsAndConditions {
            _id
            fullPath
            title {
              localized
            }
          }
        }
        menuItems {
          ...FooterMenuItems
        }
      }
    }
    offerPage: sanityPage(
      _id: { in: ["page-exclusive-offers", "drafts.page-exclusive-offers"] }
    ) {
      fullPath
    }
  }
`;

export default Footer;
